import { useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { subscribeToCrmNotificationUnreadCount } from 'services/firebase/firestore';
import {
  GET_CRM_NOTIFICATIONS,
  MARK_ALL_CRM_NOTIFICATIONS_AS_READ
} from 'services/query/SalesforceCrmNotifications.queries';
import { checkFireBaseConnection } from 'store/atoms/authAtom';
import { UseQueryType } from 'types/hooks';
import { GetCrmNotificationsResponse } from 'types/SalesforceCrmNotifications.types';

import { UseGraphQlMutation, UseGraphQlQuery } from './hooks';

const defaultConfig = {};

export const CRM_NOTIFICATIONS_DEFAULT_FILTER = {
  limit: 10,
  offset: 0
};

export const useGetCrmNotifications: UseQueryType<
  GetCrmNotificationsResponse
> = (config = defaultConfig) => UseGraphQlQuery(GET_CRM_NOTIFICATIONS, config);

export const useMarkAllCrmNotificationsAsRead = (config = defaultConfig) =>
  UseGraphQlMutation(MARK_ALL_CRM_NOTIFICATIONS_AS_READ, config);

export const useCrmNotificationUnreadCount = (userId?: string) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const isFirebaseConnected = useRecoilValue(checkFireBaseConnection);

  useEffect(() => {
    if (!userId || !isFirebaseConnected) {
      setUnreadCount(0);
      return;
    }

    const unsubscribe = subscribeToCrmNotificationUnreadCount(
      userId,
      setUnreadCount
    );

    return () => {
      unsubscribe();
    };
  }, [userId, isFirebaseConnected]);

  return { unreadCount };
};
